import { Button, Icon, IconButton, SliderModal, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Text, Box, ScrollView, Radio } from 'native-base';
import React from 'react';
import { Dimensions } from 'react-native';
import { useRecoilValue, useResetRecoilState } from 'recoil';

import { useReportsActions } from '../../../../../../../store/customerDetail/reports/actions';
import {
  reportFilterParamsState,
  reportMarketOptionState,
  reportMonthSelectedOptionsState,
  reportPeriodDatesState,
  reportPeriodOptionState,
  reportYearBrokerageOptionState,
} from '../../../../../../../store/customerDetail/reports/atom';
import {
  initialReportMarketOption,
  initialReportMonthOption,
  initialReportPeriodDates,
  currentReportYearOption,
} from '../../../../../../../store/customerDetail/reports/constants';

import { DailyPeriod } from './dailyPeriod';
import { MonthPeriod } from './monthPeriod';

import { ReportFilterTypeProps } from '.';

const { height } = Dimensions.get('window');

export const BrokerageReportsFilter: React.FC<ReportFilterTypeProps> = (props) => {
  const { goBack } = useNavigation();

  const options = [
    {
      label: 'Diário',
      value: 'Daily',
      Component: <DailyPeriod />,
    },
    {
      label: 'Mensal',
      value: 'Month',
      Component: <MonthPeriod {...props} />,
    },
  ];

  const reportPeriodOption = useRecoilValue(reportPeriodOptionState);
  const reportMarketOption = useRecoilValue(reportMarketOptionState);
  const reportMonthSelectedOptions = useRecoilValue(reportMonthSelectedOptionsState);
  const reportFilterParams = useRecoilValue(reportFilterParamsState);
  const reportPeriodDates = useRecoilValue(reportPeriodDatesState);
  const reportYearBrokerageYearOption = useRecoilValue(reportYearBrokerageOptionState);

  const resetReportYearBrokerageYearOption = useResetRecoilState(reportYearBrokerageOptionState);
  const resetReportMarketOption = useResetRecoilState(reportMarketOptionState);
  const resetReportSelectedMonthOptions = useResetRecoilState(reportMonthSelectedOptionsState);
  const resetReportFilterParams = useResetRecoilState(reportFilterParamsState);
  const resetReportPeriodDates = useResetRecoilState(reportPeriodDatesState);

  const { updateReportPeriodOption, updateReportFilterParams } = useReportsActions();

  const textButtonStyle = {
    fontFamily: Typography['fontfamily.base.semibold'],
    fontSize: Typography['fontsize.md'],
  };

  const initialReportMonthSelectedOptionsStringfy = JSON.stringify(initialReportMonthOption);
  const reportMonthSelectedOptionsStringfy = JSON.stringify(reportMonthSelectedOptions);
  const reportFilterParamsMonthSelectedOptionsStringfy = JSON.stringify(
    reportFilterParams.reportMonthSelectedOptions
  );
  const reportPeriodStartDateStringfy = JSON.stringify(
    reportPeriodDates.startDate.toISOString().slice(0, 10)
  );
  const reportPeriodEndDateStringfy = JSON.stringify(
    reportPeriodDates.endDate.toISOString().slice(0, 10)
  );
  const initialReportPeriodStartDateStringfy = JSON.stringify(
    initialReportPeriodDates.startDate.toISOString().slice(0, 10)
  );
  const initialReportPeriodEndDateStringfy = JSON.stringify(
    initialReportPeriodDates.endDate.toISOString().slice(0, 10)
  );
  const reportFilterParamsPeriodStartDateStringfy = JSON.stringify(
    reportFilterParams.reportPeriodDates.startDate.toISOString().slice(0, 10)
  );
  const reportFilterParamsPeriodEndDateStringfy = JSON.stringify(
    reportFilterParams.reportPeriodDates.endDate.toISOString().slice(0, 10)
  );

  const buttonApplyFiltersValidationIsMonth =
    reportYearBrokerageYearOption === reportFilterParams.reportYearOption &&
    reportMarketOption === reportFilterParams.reportMarketOption &&
    reportMonthSelectedOptionsStringfy === reportFilterParamsMonthSelectedOptionsStringfy;

  const buttonApplyFiltersValidationIsDaily =
    reportPeriodStartDateStringfy === reportFilterParamsPeriodStartDateStringfy &&
    reportPeriodEndDateStringfy === reportFilterParamsPeriodEndDateStringfy;

  const buttonRemoveFiltersValidationIsDaily =
    initialReportPeriodStartDateStringfy === reportFilterParamsPeriodStartDateStringfy &&
    initialReportPeriodEndDateStringfy === reportFilterParamsPeriodEndDateStringfy;

  const buttonRemoveFiltersValidationIsMonth =
    currentReportYearOption === reportFilterParams.reportYearOption &&
    initialReportMarketOption === reportFilterParams.reportMarketOption &&
    initialReportMonthSelectedOptionsStringfy === reportFilterParamsMonthSelectedOptionsStringfy;

  const buttonRemoveFiltersIsDisabled =
    reportPeriodOption === 'Month'
      ? buttonRemoveFiltersValidationIsMonth
      : buttonRemoveFiltersValidationIsDaily;

  const buttonApplyFiltersIsDisabled =
    reportPeriodOption === 'Month'
      ? buttonApplyFiltersValidationIsMonth
      : buttonApplyFiltersValidationIsDaily;

  const handleCleanFilters = () => {
    resetReportYearBrokerageYearOption();
    resetReportMarketOption();
    resetReportSelectedMonthOptions();
    resetReportFilterParams();
    resetReportPeriodDates();
    resetReportYearBrokerageYearOption();
  };

  const handleApplyFilters = () => {
    updateReportFilterParams({
      reportMarketOption,
      reportMonthSelectedOptions,
      reportYearOption: reportYearBrokerageYearOption,
      reportPeriodDates,
    });
    goBack();
  };

  const handleValueChange = (value: string) => {
    updateReportPeriodOption(value);
  };

  const handleGoBack = () => {
    goBack();
  };

  return (
    <SliderModal
      dismissWhenClickOutside
      onDismiss={handleGoBack}
      direction={'bottom'}
      modalInsideModal>
      <VStack maxHeight={{ base: height * 0.8, lg: 'full' }} flex={1}>
        <VStack
          alignItems="center"
          w="full"
          p={Spacing['inline.xxs']}
          borderTopRadius={Spacing['inline.xxxs']}
          space={Spacing['inline.xxxs']}
          backgroundColor={Color['neutral.white']}>
          <Box w="55px" background="neutral.lightest" borderRadius={BoxRadius.sm} h={1} />
          <HStack w={'full'} alignItems="center" justifyContent="space-between">
            <Text variant="semibold" fontSize={Typography['fontsize.md']}>
              Selecione o período:
            </Text>
            <IconButton
              icon="Close"
              testId={'button-close'}
              iconColor={Color['neutral.dark']}
              iconSize="xxs"
              onPress={handleGoBack}
            />
          </HStack>
          <ScrollView
            showsVerticalScrollIndicator={false}
            backgroundColor={Color['neutral.white']}
            w={'full'}>
            <Radio.Group
              space={Spacing['stack.xxxs']}
              w="full"
              p={Spacing['stack.quarck']}
              name="period-radio-group"
              defaultValue={reportPeriodOption}
              value={reportPeriodOption}
              colorScheme="black"
              onChange={handleValueChange}
              accessibilityLabel="Selecione o periodo">
              {options.map(({ label, value, Component }) => (
                <VStack key={label} space={Spacing['stack.xxxs']}>
                  <Radio
                    value={value}
                    _text={{
                      variant: 'semibold',
                      color: 'neutral.black',
                      fontSize: Typography['fontsize.md'],
                    }}>
                    {label}
                  </Radio>
                  {reportPeriodOption === value && Component}
                </VStack>
              ))}
            </Radio.Group>
          </ScrollView>
          <Box w="full" background="neutral.lightest" borderRadius={BoxRadius.sm} h={0.1} />
          <Button
            variant={'textLink'}
            isDisabled={buttonRemoveFiltersIsDisabled}
            w="full"
            onPress={handleCleanFilters}
            _text={textButtonStyle}
            rightIcon={
              <Icon
                testID="remove-filter-icon"
                name="Trash"
                color={
                  Color[buttonRemoveFiltersIsDisabled ? 'neutral.light' : 'feedback.error.default']
                }
                size="xxs"
              />
            }>
            REMOVER FILTRO
          </Button>
          <Button
            w="full"
            variant={'primary'}
            onPress={handleApplyFilters}
            _text={textButtonStyle}
            isDisabled={buttonApplyFiltersIsDisabled}>
            APLICAR FILTRO
          </Button>
        </VStack>
      </VStack>
    </SliderModal>
  );
};
